import CheckBox from './CheckBox';
import CheckBoxGroup from './CheckBoxGroup';

export { CheckBoxGroup };
export default CheckBox;
